import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS, text2XL, text3XL, text5XL, textXS } from '@styles/fonts'
import styled from 'styled-components'

export const StatisticItemsWraper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const StatisticItem = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  gap: 8px;
  padding-bottom: 16px;
`

export const StatisticItemTitle = styled.h3`
  ${text2XL};
  color: ${COLORS.navi};
  text-transform: none;
  font-family: ${FONTS.regular};
  letter-spacing: 0.1px;
`

export const StatisticItemSubTitle = styled.span`
  ${textXS};
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 4px;
`

export const StatisticItemValue = styled.span`
  ${text5XL};
  font-family: ${FONTS.bold};
  letter-spacing: 2.4px;
  color: ${COLORS.secondary};
  margin-top: auto;
`

export const StatisticItems = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  row-gap: 42px;

  @media ${DEVICES.tablet} {
    grid-template-columns: repeat(2, 1fr);

    ${StatisticItemTitle} {
      ${text2XL};
    }

    ${StatisticItemValue} {
      ${text3XL};
    }
  }

  @media ${DEVICES.mobile} {
    grid-template-columns: repeat(1, 1fr);
    gap: 24px;
    text-align: center;
  }
`
